// extracted by mini-css-extract-plugin
export default {"container":"Summary_container__xPMia","table":"Summary_table__XNIGw","th":"Summary_th__FmA+-","tdTotal":"Summary_tdTotal__PP8iL","summaryTitle":"Summary_summaryTitle__LGVLn"};